module.exports = __webpack_public_path__ + "img/1ca4251.jpg";